<template>
  <div>
    <api-loading :show="loading"></api-loading>
    <left-side
      :status="leftSideStatus"
      :isHistoryData="isHistoryData"
      :m_status_num="mStatusNum"
      :m_status="mStatus"
      :status_id="filterProp.status"
      :key_type="filterProp.keyType"
      :key_codeType="filterProp.codeType"
      :key_code="filterProp.code"
      :key_isVague="filterProp.isVague"
      :key_timeCreatedFrom="filterProp.timeCreatedFrom"
      :key_timeCreatedTo="filterProp.timeCreatedTo"
      @batchSearch="batchSearch"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :batchBool="batchBool"
        :isHistoryData="isHistoryData"
        :isAccordion="isAccordionProduct"
        :check_arr="checkArr"
        :satus_id="filterProp.status"
        :activeGroupName="activeGroupName"
        :key_type="filterProp.keyType"
        :code_type="filterProp.codeType"
        :code="filterProp.code"
        :timeCreatedFrom="filterProp.timeCreatedFrom"
        :timeCreatedTo="filterProp.timeCreatedTo"
        @accordionProducts="accordionProducts"
      />
      <div class="br-pagebody pd-lg-x-20 pd-sm-x-10" style="overflow: hidden">
        <router-view
          v-if="isSysRights('Production.getProductionOrderList')"
          :isHistoryData="isHistoryData"
          :first_loading="firstLoading"
          :loading="loading"
          :errorImg="errorImg"
          :items="items"
          :check_arr="checkArr"
          :isAccordion="isAccordionProduct"
          @deliveryOrder="deliveryOrder"
          @productCompletion="productCompletion"
          @popContact="popContact"
        ></router-view>
        <no-rights v-else></no-rights>
        <pagination
          v-if="!firstLoading"
          :cur="filterProp.page"
          :all="totalPage"
          :path="
            $route.params.time
              ? '/manufacture-order-history/' + $route.params.time + '/'
              : '/manufacture-order/'
          "
          :size="7"
          :page_size_select="pageSizeSelect"
          :rows_per_page="rowsPerPage"
          :total_count="totalCount"
          @changeRPPage="changeRPPage"
          @gotoPage="toPage"
        ></pagination>
      </div>
    </div>
    <startProductionDialog
      :dialog="startProduction"
      @close="closeStartProduct"
    />
    <productCompletionDialog
      :dialog="productComple"
      @close="closeProductCompletion"
    />
    <!-- 添加备注 -->
    <modal-order-remark :item="orderItem" />
    <!-- 导入生产单 -->
    <modal-import-production-order />
    <!-- 显示订单日志 -->
    <order-log :order_log="popOrderLog.orderLog" />
    <!-- 订单日志 -->
    <Popover
      :id="'orderLog'"
      :loading="popOrderLog.loading"
      v-show="
        $store.state.popover.id == 'orderLog' && $store.state.popover.open
      "
      :style="{
        opacity:
          $store.state.popover.id == 'orderLog' && $store.state.popover.open
            ? 1
            : 0,
      }"
    >
      <template slot="body">
        <div class="pop-inner">
          <template v-if="popOrderLog.orderLog">
            <div
              class="
                d-flex
                align-items-center
                mg-b-5
                justify-content-sm-between
              "
            >
              <span>{{ $t("rm.操作日志：") }}</span>
              <a href="javascript:;" class="tx-info" @click="openOrderLog"
                >{{ $t("rm.查看更多") }}>></a
              >
            </div>
            <template v-for="(item, i) in popOrderLog.orderLog">
              <div
                class="d-flex align-items-center mg-b-5"
                :key="i"
                v-if="i < 3"
              >
                {{ item }}
              </div>
            </template>
          </template>
        </div>
      </template>
    </Popover>
    <batch-search-dialog @handleBatchSearch="handleBatchSearch" :dialog="batchSearchDialog" v-if="batchSearchDialog.visible == true"></batch-search-dialog>
  </div>
</template>

<script>
import LeftSide from "./left-side";
import Header from "./header.vue";
import { pagination } from "@components/pagination.js"; //分页
import startProductionDialog from "./start-production-dialog.vue";
import productCompletionDialog from "./product-completion-dialog.vue";
import ModalOrderRemark from "./modal-order-remark.vue";
import ModalImportProductionOrder from "./modal-import-order.vue";
import OrderLog from "./order-log.vue";
import Popover from "@components/Popover.vue";
import BatchSearchDialog from '../../distributor/batch-search-dialog.vue'

export default {
  components: {
    BatchSearchDialog,
    LeftSide,
    Header,
    pagination,
    startProductionDialog,
    productCompletionDialog,
    ModalOrderRemark,
    ModalImportProductionOrder,
    OrderLog,
    Popover,
  },
  data() {
    return {
      loading: false,
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      isHistoryData: this.$route.params.time ? true : false, //是否是历史数据
      selectedTime: this.$route.params.time
        ? this.$route.params.time
        : moment().subtract(3, "month").format("YYYY-MM"), //已选择的时间
      mStatusNum: "",
      mStatus: {
        1: { id: "1", name: this.$t("rm.待生产") },
        2: { id: "2", name: this.$t("rm.生产中") },
        3: { id: "3", name: this.$t("order.已完成") },
        4: { id: "4", name: this.$t("order.已取消") },
      },
      firstLoading: true,
      totalPage: 1,
      pageSizeSelect: [10, 20, 50],
      rowsPerPage: parseInt(store.get("m-order-rowsPerPage"))
        ? parseInt(store.get("m-order-rowsPerPage"))
        : 10,
      totalCount: 0,
      items: [],
      checkArr: [],
      // 订单状态名
      activeGroupName: "",
      filterProp: {
        // 当前页数
        page: this.$route.params.page ? this.$route.params.page : 1,
        // 订单状态
        status: this.$route.query.status ? this.$route.query.status : "",
        // 订单类型
        keyType: "",
        // 编号类型,1=采购单号,2=生产单号,3=SKU名称,4=SKU编号
        codeType: 1,
        code: "",
        // SKU模糊搜索
        isVague: "",
        // 起始日期
        timeCreatedFrom: "",
        // 截止日期
        timeCreatedTo: "",
      },
      errorImg: {}, //错误的图片
      isAccordionProduct: store.get("isAccordionProduct-M-order"),
      //开始生产
      startProduction: {
        visible: false,
        item: {},
        data: {},
      },
      //生产完成
      productComple: {
        visible: false,
        item: {},
        data: [],
      },
      // 订单对象
      orderItem: {},
      // 订单日志参数
      popOrderLog: {
        loading: false,
        orderLog: "",
      },
      popOrderLogDefault: "",
      batchSearchDialog:{
        visible: false,
        key: '',
      },
      batchSearchParams: {},
      batchBool: false,
    };
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("m-order-rowsPerPage", this.rowsPerPage);
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.popOrderLogDefault = JSON.stringify(this.popOrderLog);
    this.getOrder();
    this.getStatusNum();
  },
  methods: {
    batchSearch(key){
      this.batchSearchDialog = {
        visible: true,
        key: key
      }
    },
    // 飘窗
    popContact(event, item, id, obj) {
      if (event.type == "mouseenter") {
        //打开
        this.$store.commit("setPopover", {
          id,
          event,
        });
        switch (id) {
          case "orderLog":
            this.popOrderLog = JSON.parse(this.popOrderLogDefault);
            this.popOrderLog.orderLog = item.orderLog;
            break;
        }
      } else {
        this.$store.commit("setPopover", { event });
      }
    },
    // 显示更多操作日志
    openOrderLog() {
      $("#modalMLog").modal("show");
    },
    //新建生产单
    addProductOrder() {
      this.$router.push({
        name: "addProductOrder",
      });
    },
    //开始生产
    deliveryOrder(item, bool, indexjson) {
      this.loading = true;
      let params = {
        orderId: item.id,
      };
      if (bool == true) {
        params.skuId = item.itemJson[indexjson].id;
      }
      console.log(item, "开始生产row信息");
      $.api_call("api.Production.getProductionOrder", params, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          console.log(r);
          this.startProduction = {
            visible: true,
            item: item,
            data: r.Data.Results,
          };
        } else {
          ShowTip(r.Message, "danger");
        }
      });
    },
    //关闭开始生产弹窗
    closeStartProduct(bool) {
      if (bool == true) {
        this.startProduction = {
          visible: false,
          item: {},
          data: {},
        };
        this.getOrder();
      } else {
        this.startProduction = {
          visible: false,
          item: {},
          data: {},
        };
      }
    },
    //生产完成
    productCompletion(item, bool, indexjson) {
      this.loading = true;
      let params = {
        orderId: item.id,
      };
      if (bool == true) {
        params.skuId = item.itemJson[indexjson].id;
      }
      console.log(item, "生产完成row信息");
      $.api_call("api.Production.findsSkuBatch", params, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          console.log(r);
          this.productComple = {
            visible: true,
            item: item,
            data: r.Data.Results || [],
          };
        } else {
          ShowTip(r.Message, "danger");
        }
      });
    },
    //关闭开始生产弹窗
    closeProductCompletion(bool) {
      if (bool == true) {
        this.productComple = {
          visible: false,
          item: {},
          data: [],
        };
        this.getOrder();
      } else {
        this.productComple = {
          visible: false,
          item: {},
          data: [],
        };
      }
    },
    handleBatchSearch(item){
      this.batchSearchParams = item
      this.batchBool = true
      this.filterProp.page = 1
      this.rowsPerPage = 10
      this.getOrder()
    },

    getOrder(type,batch) {
      if (!this.isSysRights("Production.getProductionOrderList")) return;
      if(batch == 'common') {
        this.batchBool = false
      }
      this.loading = true;
      let getData = (data) => {
        this.errorImg = {}; //重置不能载入的图片系列
        this.items = data.Results ? data.Results : [];
        this.totalPage = data.Pagination.totalPage;
        if (this.filterProp.page > this.totalPage) {
          this.filterProp.page = this.totalPage ? this.totalPage : 1;
          this.$router.push({ params: { page: this.filterProp.page } });
        }
        this.totalCount = data.Pagination.totalCount;
        if (!type) $("html,body").scrollTop(0);
        if (this.items && this.items.length > 0) {
          this.items.forEach((e, i) => {
            this.$set(e, "moreCode", false);
            this.$set(e, "innerTableStatus", false);
          });
        }
        if (!this.isAccordionProduct) {
          setTimeout(() => {
            this.items.forEach((e, i) => {
              this.$set(e, "innerTableStatus", true);
            });
          }, 500);
        }
      };
      let params = {
          rowsPerPage: this.rowsPerPage,
          page: this.filterProp.page,
          type: this.filterProp.keyType,
          status: this.filterProp.status,
          codeType: this.filterProp.codeType,
          code: this.filterProp.code,
          isVague: this.filterProp.isVague,
          startTime: this.filterProp.timeCreatedFrom,
          endTime: this.filterProp.timeCreatedTo,
        }
      if(Object.keys(this.batchSearchParams).length !== 0 && this.batchBool){
        params = {
          batchSearch: this.batchSearchParams,
          page: this.filterProp.page,
          rowsPerPage: this.rowsPerPage,
        }
      }
      $.api_call(
        "api.Production.getProductionOrderList",
        params,
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            getData(r.Data);
            if(Object.keys(this.batchSearchParams).length !== 0){
              this.batchSearchDialog.visible = false
            }
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    getStatusNum() {
      if (!this.isSysRights("Production.getProductionStatusCount")) return;
      if (this.isHistoryData) {
        this.rmStatusNum = {};
        return;
      }
      let getData = (data) => {
        this.mStatusNum = data;
      };
      let params = {};
      let url = "api.Production.getProductionStatusCount";
      let [year, month] = [
        this.selectedTime.split("-").shift().substring(2, 4),
        this.selectedTime.split("-").pop(),
      ];
      if (this.isHistoryData) (params.year = year), (params.month = month);
      $.api_call(url, params, function (r) {
        if (r.ErrorCode == "9999") {
          getData(r.Data.Results);
        } else {
          ShowTip(r.Message, "danger");
        }
      });
    },
    gotoPage() {
      this.filterProp.page = this.$route.params.page
        ? this.$route.params.page
        : 1;
      this.getOrder();
    },
    changeRPPage(num) {
      let page = this.filterProp.page;
      this.rowsPerPage = num;
      this.filterProp.page = 1;
      if (this.$route.params.time) {
        this.$router.push({
          path: `${this.$route.meta.url}/${this.$route.params.time}/1`,
        });
      } else {
        this.$router.push({ path: `${this.$route.meta.url}/1` });
      }
      if (page == 1) {
        this.getOrder();
      }
    },
    toPage(num) {
      let page = this.filterProp.page;
      if (this.$route.params.time) {
        this.$router.push({ params: { page: num } });
      } else {
        this.$router.push({ path: `${this.$route.meta.url}/${num}` });
      }
      if (page == num) {
        this.getOrder();
      }
    },
    // 商品折叠
    accordionProducts(type) {
      store.set("isAccordionProduct-M-order", type);
      this.isAccordionProduct = type;
      if (!type) {
        this.items.forEach((e, i) => {
          this.$set(e, "innerTableStatus", true);
        });
      }
    },
  },
};
</script>